import { Loaders } from "../../common/store/loaders/loaders.enum";
import useLoaders from "../../hooks/use-loaders.hook";

interface SuspenseProps {
  children: React.ReactNode;
  fallback: React.ReactNode;
  loaders: Loaders | Loaders[];
  forceShow?: boolean;
}

const Suspense = ({ children, fallback, loaders, forceShow = false }: SuspenseProps): React.ReactElement => {
  const { isLoading } = useLoaders({ loaders });
  
  if (!forceShow && isLoading) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}

export default Suspense;
